import classNames from "classnames";
import React from "react";
import { ReactComponent as Done } from "assets/img/svg/done-bullet.svg";

const BulletPont = ({ step, isActive, currentStep }) => {
  const buttonClass = classNames({
    stepper_bullet: true,
    "text-bold": true,
    active_bullet: isActive,
  });
  if (step-1 < currentStep) return <div className="mr-2"><Done /></div>;
  return <div className={buttonClass}>{step}</div>;
};

export default BulletPont;
